import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  data: null,
  autoplay: 1,
  centered: false,
  show: false,
  mattressData:"70I8Ti2xRvA"
}
// youtube mattress builder id video url id
// 70I8Ti2xRvA
// U1tDXDH6iak
const learnByVideo = createSlice({
  name: 'learnByVideo',
  initialState,
  reducers: {
    resetState: (state) => {
      return {
        ...initialState
      }
    },
    setData: (state, {payload}) => {
      state.data = payload;
    },
    show: (state) => {
      state.show = true;
    },
    close: (state) => {
      state.show = false;
      state.autoplay = 1;
      state.centered = false;
    },
    setCentered: (state, {payload}) => {
      state.centered = payload
    },
    setAutoplay: (state, {payload}) => {
      state.autoplay = payload
    },
  },
});

export const learnByVideoActions = learnByVideo.actions;
export const learnByVideoSelector = (state) => state.learnByVideo;
export const learnByVideoReducer = learnByVideo.reducer;
export default learnByVideoReducer;

export const selectVideo = (state) => state.learnByVideo.data;
export const selectMattressDataVideo = (state) => state.learnByVideo.mattressData;
export const selectIsVideoModalCentered = (state) => state.learnByVideo.centered;
export const selectIsAutoplay = (state) => state.learnByVideo.autoplay;
export const selectShow = (state) => state.learnByVideo.show;